var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurrenderdPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fefdef",
    d: "M80,84H20c-1.105,0-2-0.895-2-2V25c0-3.314,2.686-6,6-6h52c3.314,0,6,2.686,6,6v57C82,83.105,81.105,84,80,84z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f37e98",
    d: "M76,19H24c-3.314,0-6,2.686-6,6v9h64v-9C82,21.686,79.314,19,76,19z M26.5,28.5c-1.105,0-2-0.895-2-2s0.895-2,2-2s2,0.895,2,2S27.605,28.5,26.5,28.5z M73.5,28.5c-1.104,0-2-0.895-2-2s0.896-2,2-2s2,0.895,2,2S74.604,28.5,73.5,28.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M80,85H20c-1.654,0-3-1.346-3-3V25c0-3.859,3.141-7,7-7h52c3.859,0,7,3.141,7,7v57C83,83.654,81.654,85,80,85z M24,20c-2.757,0-5,2.243-5,5v57c0,0.552,0.448,1,1,1h60c0.552,0,1-0.448,1-1V25c0-2.757-2.243-5-5-5H24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M47,23c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C48,22.553,47.553,23,47,23z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M41,23c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C42,22.553,41.553,23,41,23z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M35,23c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C36,22.553,35.553,23,35,23z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M29,23c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C30,22.553,29.553,23,29,23z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M53,23c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C54,22.553,53.553,23,53,23z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M59,23c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C60,22.553,59.553,23,59,23z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M65,23c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C66,22.553,65.553,23,65,23z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M71,23c-0.553,0-1-0.447-1-1v-6c0-0.553,0.447-1,1-1s1,0.447,1,1v6C72,22.553,71.553,23,71,23z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M26.5,29c-1.379,0-2.5-1.121-2.5-2.5s1.121-2.5,2.5-2.5s2.5,1.121,2.5,2.5S27.879,29,26.5,29z M26.5,25c-0.827,0-1.5,0.673-1.5,1.5s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S27.327,25,26.5,25z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M73.5,29c-1.379,0-2.5-1.121-2.5-2.5s1.121-2.5,2.5-2.5s2.5,1.121,2.5,2.5S74.879,29,73.5,29z M73.5,25c-0.827,0-1.5,0.673-1.5,1.5s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S74.327,25,73.5,25z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M71.5,34h-53c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h53c0.276,0,0.5,0.224,0.5,0.5S71.776,34,71.5,34z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M75.5,34h-2c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h2c0.276,0,0.5,0.224,0.5,0.5S75.776,34,75.5,34z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M81.5,34h-4c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h4c0.276,0,0.5,0.224,0.5,0.5S81.776,34,81.5,34z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#60be92",
    d: "M47.501,70.501c-0.48,0-0.965-0.172-1.348-0.52l-12-12c-0.816-0.742-0.875-2.008-0.133-2.828c0.742-0.813,2.008-0.875,2.824-0.133l10.629,10.754l17.652-17.727c0.805-0.762,2.066-0.727,2.828,0.078c0.758,0.805,0.723,2.07-0.082,2.828l-19,19C48.489,70.318,47.993,70.501,47.501,70.501z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M47.499,71c-0.625,0-1.223-0.23-1.684-0.652L33.8,58.332c-0.477-0.43-0.766-1.047-0.797-1.715c-0.031-0.664,0.195-1.305,0.645-1.801c0.93-1.016,2.516-1.09,3.531-0.164l10.293,10.41l17.301-17.371c0.496-0.469,1.148-0.695,1.797-0.691c0.668,0.02,1.289,0.297,1.746,0.781c0.461,0.488,0.703,1.121,0.684,1.789s-0.297,1.289-0.785,1.746l-18.99,18.993C48.749,70.758,48.14,71,47.499,71z M35.507,55c-0.406,0-0.82,0.164-1.117,0.492c-0.27,0.297-0.406,0.68-0.387,1.078c0.016,0.402,0.191,0.77,0.484,1.039l12.02,12.02c0.527,0.477,1.469,0.48,2.023-0.039l18.988-18.988c0.301-0.285,0.469-0.656,0.48-1.059c0.012-0.398-0.137-0.781-0.41-1.07c-0.273-0.293-0.648-0.461-1.05-0.473c-0.391-0.02-0.777,0.133-1.07,0.41L47.827,66.125c-0.094,0.094-0.223,0.148-0.355,0.148s-0.262-0.055-0.355-0.148l-10.63-10.754C36.214,55.121,35.862,55,35.507,55z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurrenderdPic);
export default __webpack_public_path__ + "static/media/surrenderd_pic.e8f46e6f805e96d7b04e9d4945692f8b.svg";
export { ForwardRef as ReactComponent };